module.exports = __webpack_public_path__ + "static/gothic-a1-v8-latin-300-dc05976cc318d9f778248a1d7226c37e.woff2";